import React from 'react';
import RoomsList from './RoomsList';
import AboutTab from './tabs/AboutTab';
import FacilityTab from './tabs/FacilityTab';
import LocationTab from './tabs/LocationTab';

const TabSection = ({ roomDetails, roomListings, query }) => {
  return (
    <div className="description-section tab-section">
      <div className="menu-top menu-up">
        <ul className="nav nav-tabs" id="top-tab" role="tablist">
          <li className="nav-item">
            <a 
              className="nav-link active"
              data-bs-toggle="tab"
              href="#rooms"
              role="tab"
            >
              Room
            </a>
          </li>
          <li className="nav-item">
            <a 
              className="nav-link"
              data-bs-toggle="tab"
              href="#about"
              role="tab"
            >
              About
            </a>
          </li>
          <li className="nav-item">
            <a 
              className="nav-link"
              data-bs-toggle="tab"
              href="#facility"
              role="tab"
            >
              Facility
            </a>
          </li>
          <li className="nav-item">
            <a 
              className="nav-link"
              data-bs-toggle="tab"
              href="#location"
              role="tab"
            >
              Location
            </a>
          </li>
          <li className="nav-item">
            <a 
              className="nav-link"
              data-bs-toggle="tab"
              href="#reviews"
              role="tab"
            >
              Reviews
            </a>
          </li>
          <li className="nav-item">
            <a 
              className="nav-link"
              data-bs-toggle="tab"
              href="#policies"
              role="tab"
            >
              Policies
            </a>
          </li>
        </ul>
      </div>

      <div className="description-details tab-content" id="top-tabContent">
        <div className="menu-part tab-pane fade show active" id="rooms">
          <RoomsList roomListings={roomListings} query={query} />
        </div>
        <div className="about menu-part tab-pane fade" id="about">
          <AboutTab />
        </div>
        <div className="tab-pane fade" id="facility" role="tabpanel">
          <FacilityTab roomDetails={roomDetails} />
        </div>
        <div className="tab-pane fade" id="location" role="tabpanel">
          <LocationTab location={roomDetails?.location} />
        </div>
        <div className="tab-pane fade" id="reviews" role="tabpanel">
          <div className="card w-100 h-100">
            <div className="card-body p-8">
              {/* Reviews content will go here */}
            </div>
          </div>
        </div>
        <div className="tab-pane fade" id="policies" role="tabpanel">
          <div className="card w-100 h-100">
            <div className="card-body p-8">
              {/* Policies content will go here */}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TabSection;
